<div
  class="multi-values-content"
  [class.multi-values-content--editable]="editable()"
  (click)="onCellClick($event)"
>
  <mat-chip-set>
    @if (!isExpanded && values()?.length > 1) {
      <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
        <div class="multi-values-content__showmore">
          <mat-chip (click)="onChipClick($event)">{{ values()?.[0] }}</mat-chip>
          <button
            mat-flat-button
            class="multi-values-content__chip-showmore"
            [matTooltip]="showMoreTooltip()"
            (click)="onClickShowMore($event)"
          >
            +{{ values()?.length - 1 }}
          </button>
        </div>
      </div>
    } @else {
      @for (value of values(); track value) {
        <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
          <mat-chip (click)="onChipClick($event)">{{ value }}</mat-chip>
        </div>
      }
      @if (values()?.length > 1) {
        <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
          <button
            mat-flat-button
            class="multi-values-content__chip-showmore"
            [matTooltip]="showMoreTooltip()"
            (click)="onClickShowLess($event)"
          >
            <mat-icon>arrow_left</mat-icon>
          </button>
        </div>
      }
    }
  </mat-chip-set>
  @if (!values()?.length) {
    <span class="multi-values-content__empty">{{ emptySymbol() }}</span>
  }
</div>
